import React, { useState } from 'react';
import { signUp, logIn } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import { updateProfile } from 'firebase/auth';
import { auth } from '../firebase';

const SignUpPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    address: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { updateUserProfile, refreshUser } = useUser();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      setError("The passwords you entered don't match. Please try again.");
      return;
    }

    if (formData.password.length < 6) {
      setError("Your password must be at least 6 characters long. Please choose a stronger password.");
      return;
    }

    try {
      const user = await signUp(formData.email, formData.password, formData.name, formData.address, false);
      await updateProfile(auth.currentUser, { displayName: formData.name });
      await logIn(formData.email, formData.password);
      await updateUserProfile({
        displayName: formData.name,
        address: formData.address,
        onboardingCompleted: false,
      });
      await refreshUser();

      setSuccess('Your account has been created successfully! You will be redirected to the onboarding page shortly.');
      setTimeout(() => {
        navigate('/onboarding');
      }, 3000);
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        setError('An account with this email already exists. Please use a different email or try logging in.');
      } else if (error.code === 'auth/invalid-email') {
        setError('The email address you entered is not valid. Please check and try again.');
      } else {
        setError('An error occurred while creating your account. Please try again later.');
      }
    }
  };

  return (
    <div className="container max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Sign Up</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="name" className="block mb-1 font-medium">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            autoComplete="name"
          />
        </div>
        <div>
          <label htmlFor="email" className="block mb-1 font-medium">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            autoComplete="email"
          />
        </div>
        <div>
          <label htmlFor="address" className="block mb-1 font-medium">Address:</label>
          <textarea
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            autoComplete="street-address"
          />
        </div>
        <div>
          <label htmlFor="password" className="block mb-1 font-medium">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            autoComplete="new-password"
          />
          <p className="mt-1 text-sm text-gray-600">Password must be at least 6 characters long.</p>
        </div>
        <div>
          <label htmlFor="confirmPassword" className="block mb-1 font-medium">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            autoComplete="new-password"
          />
        </div>
        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Sign Up
          </button>
        </div>
      </form>
      {error && (
        <p className="mt-4 p-2 rounded bg-red-100 text-red-700">
          {error}
        </p>
      )}
      {success && (
        <p className="mt-4 p-2 rounded bg-green-100 text-green-700">
          {success}
        </p>
      )}
    </div>
  );
};

export default SignUpPage;
